<template>
  <v-toolbar app flat color="grey darken-3" style="height:64px!important;">
    <v-spacer></v-spacer>
    <v-btn
      depressed
      class="success white--text mr-3"
      v-on:click="account" v-show="isAdmin"
    >
      <span>Switch to Site</span>
    </v-btn>

    <amplify-sign-out v-if="user"></amplify-sign-out>
    <v-btn
      v-else
      flat
      outline
      color="white"
      v-on:click="signIn"
    >
     <span>Sign In</span>
    </v-btn>
  </v-toolbar>

</template>

<script>
import AmplifyStore from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminMenu',
  data () {
    return {
      logo: {
        src: 'heading2.png'
      },
      biker: {
        src: 'biker1.jpg'
      },
      heading: {
        src: 'heading1.jpg'
      }
    }
  },
  computed: {
    user () {
      return AmplifyStore.state.user.user
    },
    ...mapGetters([
      'isAdmin'
    ])
  },
  methods: {
    home: function () {
      this.$router.push('/')
    },
    account: function () {
      this.$router.push('/account')
    },
    dashboard: function () {
      this.$router.push('/admin')
    },
    signIn: function () {
      this.$router.push('/auth?redirect=%2Faccount')
    },
    signOut: function () {
      this.$router.push('/auth/signOut')
    }
  }
}
</script>
<style>
  .Button__button___1FrBC {
    padding: 0 16px!important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 2px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 36px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    font-size: 14px;
    background-color: orange;
    border: solid 1px orange;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 13px 0 0;
    min-width: 88px!important;
    outline: 0;
    text-transform: uppercase;
    text-decoration: none;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    position: relative;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
